'use es6';

import { createSelector } from 'reselect';
import { createSendCreditsSelector } from 'EmailData/selectors/portalSendCreditsSelectors';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
import { getEmailType } from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { EMAIL_TYPE } from 'messaging-types-lib/content/contentEmail';
const portalSendCreditSelectors = createSendCreditsSelector();

// Wrap each selector in the portalSendCreditSelectors object
Object.keys(portalSendCreditSelectors).forEach(selectorName => portalSendCreditSelectors[selectorName] = basicSelectorWithStats(portalSendCreditSelectors[selectorName]));
const EMAIL_TYPES_WITHOUT_SEND_LIMIT = [EMAIL_TYPE.FEEDBACK_NPS_EMAIL, EMAIL_TYPE.FEEDBACK_CES_EMAIL, EMAIL_TYPE.FEEDBACK_CUSTOM_EMAIL, EMAIL_TYPE.FEEDBACK_CUSTOM_SURVEY_EMAIL];
export const getPortalSendCredits = portalSendCreditSelectors.getPortalSendCredits;
export const getEmailCreditUsed = portalSendCreditSelectors.getEmailCreditUsed;
export const getEmailCreditLimit = portalSendCreditSelectors.getEmailCreditLimit;
export const getIsHardLimited = portalSendCreditSelectors.getIsHardLimited;
export const getHasHardSendLimits = portalSendCreditSelectors.getHasHardSendLimits;
export const getEmailCreditWarningThreshold = portalSendCreditSelectors.getEmailCreditWarningThreshold;
export const getHasPortalReachedLimit = portalSendCreditSelectors.getHasPortalReachedLimit;
export const getHasPortalReachedThreshold = portalSendCreditSelectors.getHasPortalReachedThreshold;
export const getShouldApplyLimitToEmailType = createSelector(getEmailType, emailType => !EMAIL_TYPES_WITHOUT_SEND_LIMIT.includes(emailType));